module.exports = __webpack_public_path__ + "static/img/ganganjiuPic.2684b439.png";